import React, { useEffect, useState } from "react";
import "./Checkout.scss";
import CartItem from "@components/CartItem/CartItem";
import { Row, Col, List, Divider, Button, Select, Radio } from "antd";
import { useCart } from "contexts/CartContext";
import { useNavigate } from "react-router-dom";
import { PlusOutlined, StarFilled } from "@ant-design/icons";
import contact from "@assets/icons/contact.svg";
import locationMarker from "@assets/icons/location-marker.svg";
import Helpers from "@utils/Helpers";
import { useUnit } from "contexts/UnitContext";
import ProfileMap from "@components/ProfileMap/ProfileMap";
import { useUser } from "contexts/UserContext";
import { ProductApi } from "services/ProductApi";
import { errorLog } from "logging";
import { useAuth } from "contexts/AuthContext";
import debit from "@assets/icons/debit.svg";
import visa from "@assets/icons/visa.svg";
import mastercard from "@assets/icons/mastercard.svg";
import amex from "@assets/icons/american-express.svg";
import paypal from "@assets/icons/paypalRec.svg";
import crownImg from "@assets/icons/crown.svg";
import cash from "@assets/icons/cash.png";
import { IUserAddress } from "@utils/Interfaces";
import { paymentApi } from "services/PaymentApi";
import { PayPalButtons } from "@paypal/react-paypal-js";
import PaymentModal from "@components/PaymentModal/PaymentModal";
import { Link } from "react-router-dom";
const { Option } = Select;

const cardIcons: Record<string, string> = {
  visa,
  mastercard,
  amex,
  paypal,
};

const Checkout: React.FC = () => {
  const { userCart, productSelected, setProductSelected, setIsRefreshCart } =
    useCart();
  const { userProfile, userAddresses } = useUser();
  const { setLoading } = useAuth();
  const { units, convertCurrency } = useUnit();
  const [carts, setCarts] = useState<any[]>([]);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const productToBuyNow = urlParams.get("productId");
  const [isOpenNewCard, setIsOpenNewCard] = useState(false);
  const [productOnCheckout, setProductOnCheckout] = useState<any[]>([]);
  const [shippingOptions, setShippingOptions] = useState(null);
  const [shippingFeeRadio, setShippingFeeRadio] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(
    userAddresses?.[0]?.address_id
  );
  const [selectedPostion, setSelectedPostion] = useState<[number, number]>();
  const [selectedLocation, setSelectedLocation] = useState<any>({});
  const [orderPayload, setOrderPayload] = useState<any>({
    address: {} as IUserAddress,
    shipping_method_id: undefined,
    payment_info_id: null,
    estimate_tax: 0,
    transaction_fee: 0,
    shipping_fee: 0,
    total_price: 0,
    orders: [],
  });
  const [allPayment, setAllPayment] = useState<any>(null);

  // useEffect(() => {
  //   const getAllPayment = async () => {
  //     try {
  //       const response = await paymentApi.getAllPayment();
  //       if (response.status === 200) {
  //         let data = response.data.data;
  //         if (data && data.length > 0) {
  //           const defaultCards = data.filter((item: any) => item.is_default);

  //           if (defaultCards.length === 0) {
  //             const newestCard = data.reduce((acc: any, curr: any) =>
  //               curr.payment_info_id > acc.payment_info_id ? curr : acc
  //             );
  //             newestCard.is_default = true;
  //           } else if (defaultCards.length > 1) {
  //             const newestDefault = defaultCards.reduce((acc: any, curr: any) =>
  //               curr.payment_info_id > acc.payment_info_id ? curr : acc
  //             );

  //             data = data.map((item: any) => {
  //               if (item.payment_info_id === newestDefault.payment_info_id) {
  //                 return { ...item, is_default: true };
  //               }
  //               return { ...item, is_default: false };
  //             });
  //           }

  //           data.sort((a: any, b: any) => {
  //             if (a.is_default && !b.is_default) return -1;
  //             if (!a.is_default && b.is_default) return 1;
  //             return b.payment_info_id - a.payment_info_id;
  //           });
  //         }
  //         setAllPayment(data);
  //         setOrderPayload((prevState: any) => ({
  //           ...prevState,
  //           payment_info_id: data.find((item: any) => item.is_default)
  //             ?.payment_info_id,
  //         }));
  //       }
  //     } catch (error) {
  //       Helpers.notification.warning("Can not fetch payment. Please try again");
  //       errorLog("Checkout.tsx - getAllPayment", error);
  //     }
  //   };
  //   if (!allPayment) {
  //     getAllPayment();
  //   }
  // }, [allPayment]);

  useEffect(() => {
    if (userAddresses) {
      const selected = userAddresses.find(
        (item: any) => item.address_id === selectedAddressId
      );
      if (selected) {
        setSelectedPostion([selected.lat || 0, selected.lon || 0]);
        setOrderPayload({
          ...orderPayload,
          address: selected,
        });
      }
    }
  }, [selectedAddressId, userAddresses]);

  const calculateProductPrice = (product: any) => {
    let linePrice = 0;
    if (product.unit === "Ton") {
      linePrice =
        product.quantity *
        (product.bale_weight / 1000) *
        convertCurrency(
          product.discounted_price
            ? product.discounted_price
            : product.price_per_tons,
          "USD",
          units.currency
        );
    } else {
      linePrice =
        product.quantity *
        convertCurrency(
          product.discounted_price
            ? product.discounted_price
            : product.price_per_bale,
          "USD",
          units.currency
        );
    }
    const quantity = product.quantity || 1;
    return Math.round((linePrice / quantity) * 100) / 100;
  };

  // MAPPING DATA TO CART
  useEffect(() => {
    if (carts.length > 0) {
      const newOrders = carts.map((item) => {
        const producerDistance = Helpers.HaversineDistance(
          orderPayload.address.lat,
          orderPayload.address.lon,
          item[0].farm_details.lat,
          item[0].farm_details.lon
        );
        const orderItem: any = {
          producer_id: item[0].farm_details.producer_id,
          distance: producerDistance || 0,
          order_items: item.map((product: any) => {
            const productPrice = calculateProductPrice(product);
            return {
              product_id: product.product_id,
              quantity: product.quantity,
              product_total_price: productPrice,
            };
          }),
        };
        return orderItem;
      });
      setOrderPayload({ ...orderPayload, orders: newOrders });
    }
  }, [carts]);

  // HANDLE CONTRUCT DATA ON CHECKOUT
  useEffect(() => {
    let productSelectedTmp = [...productSelected];
    if (productToBuyNow) {
      productSelectedTmp = productSelectedTmp.map((item) => {
        if (item.productId === Number(productToBuyNow)) {
          return {
            ...item,
            isSelected: true,
          };
        }
        return {
          ...item,
          isSelected: false,
        };
      });
    }
    if (productOnCheckout.length === 0 && productSelectedTmp) {
      const productSelectedIds = productSelectedTmp
        .filter((item) => item.isSelected === true)
        .map((item) => item.productId);

      const filteredProduct = userCart.filter((item: any) =>
        productSelectedIds.includes(item.product_id)
      );

      setProductOnCheckout(filteredProduct);
    }
  }, [productSelected, productToBuyNow]);

  // HANDLE CALCULATE SUBTOTAL & REFACTOR CART
  useEffect(() => {
    if (productOnCheckout.length > 0) {
      let subTotalPrice: any = 0;

      productOnCheckout.forEach((item: any) => {
        const unitPrice = calculateProductPrice(item);
        subTotalPrice += unitPrice * (item.quantity || 1);
      });
      const roundedSubTotal = Math.round(subTotalPrice * 100) / 100;
      setOrderPayload({
        ...orderPayload,
        total_price: roundedSubTotal,
        estimate_tax: Math.round(roundedSubTotal * 0.1 * 100) / 100,
      });

      const groupedData: any = Object.values(
        productOnCheckout.reduce((acc: any, item: any) => {
          const displayName = item.farm_details.display_name;
          if (!acc[displayName]) {
            acc[displayName] = [];
          }
          acc[displayName].push(item);
          return acc;
        }, {})
      );
      setCarts(groupedData);
    }
  }, [productOnCheckout]);

  useEffect(() => {
    const getShippingOptions = async () => {
      try {
        const response = await ProductApi.GetProductDetail(
          productOnCheckout[0].product_id
        );
        if (response.status === 200) {
          setShippingOptions(response.data.data.shipping_option_details);
        }
      } catch (error) {
        Helpers.notification.error("Can not fetch data. Please try again");
        errorLog("Checkout.tsx - getShippingOptions", error);
      }
    };
    if (productOnCheckout.length > 0) {
      getShippingOptions();
    }
  }, [productOnCheckout]);

  // HANDLE MAPPING ADDRESS
  useEffect(() => {
    if (Object.keys(selectedLocation).length > 0) {
      setOrderPayload({
        ...orderPayload,
        address: {
          ...orderPayload.address,
          postal_code: selectedLocation.postCode,
          street: selectedLocation.address.road
            ? selectedLocation.address.road
            : selectedLocation.display_name,
          city: selectedLocation.address.city
            ? selectedLocation.address.city
            : selectedLocation.address.town
            ? selectedLocation.address.town
            : selectedLocation.address.county
            ? selectedLocation.address.county
            : selectedLocation.address.village,
          province: selectedLocation.address.province
            ? selectedLocation.address.province
            : selectedLocation.address.state
            ? selectedLocation.address.state
            : selectedLocation.address.city,
          apartment: "",
          lat: selectedLocation.lat,
          lon: selectedLocation.lon,
        },
      });
    }
  }, [selectedLocation]);

  // HANDLE CHECKOUT
  const handleCheckout = async () => {
    if (!orderPayload.shipping_method_id) {
      Helpers.notification.warning("Please select shipping method");
      return;
    }
    setLoading(true);
    try {
      const finalTotal =
        Math.round(
          (orderPayload.total_price +
            (orderPayload.shipping_fee || 0) +
            (orderPayload.estimate_tax || 0) +
            (orderPayload.transaction_fee || 0)) *
            100
        ) / 100;
      const payload = {
        ...orderPayload,
        total_price: finalTotal,
        estimate_tax:
          Math.round((orderPayload.estimate_tax || 0) * 100) / 100,
        shipping_fee:
          Math.round((orderPayload.shipping_fee || 0) * 100) / 100,
      };
      const response = await ProductApi.Order(payload);
      if (
        response.status === 200 &&
        response.data.message === "Order created successfully"
      ) {
        const encodedResponse = encodeURIComponent(
          JSON.stringify(response.data.data)
        );
        setLoading(false);
        setIsRefreshCart(true);
        navigate(`/complete?response=${encodedResponse}`);
      }
    } catch (error: any) {
      setLoading(false);
      if (error.response.status === 400) {
        Helpers.notification.warning(error.response.data.message);
        return;
      }
      Helpers.notification.error("Something wrong in server");
      errorLog("Checkout.tsx - handleCheckout", error);
    }
  };

  const onCreatePaypalOrder = (data: any, actions: any) => {
    const totalPay = (
      Math.round(
        (orderPayload.total_price +
          (orderPayload.shipping_fee || 0) +
          (orderPayload.estimate_tax || 0)) *
          100
      ) / 100
    ).toFixed(2);
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Order",
            amount: {
              currency_code: "USD",
              value: totalPay.toString(),
            },
          },
        ],
      })
      .then((orderID: any) => {
        return orderID;
      });
  };

  return (
    <div className="Checkout">
      <div className="container">
        <div className="page-title">Checkout</div>
        <Row gutter={14}>
          <Col span={16}>
            <div className="delivering-info">
              <div className="title">Delivering To</div>
              <Row gutter={14}>
                <Col span={12}>
                  <div className="delivering-options">
                    <Select
                      value={selectedAddressId}
                      className="address-select"
                      onChange={(value) => setSelectedAddressId(value)}
                      variant="filled"
                    >
                      {userAddresses?.map((item: any, index: number) => {
                        return (
                          <Option value={item.address_id} key={index}>
                            {item.label}
                          </Option>
                        );
                      })}
                    </Select>
                    <div className="address-mapping-label">
                      <div className="name">
                        {userProfile?.first_name} {userProfile?.last_name}
                      </div>
                      <div className="phone">{orderPayload.address.phone}</div>
                      <div className="address">
                        {orderPayload.address.street},{" "}
                        {orderPayload.address.city},{" "}
                        {orderPayload.address.province}
                      </div>
                    </div>
                    <Link to="/profile" className="manage-info">
                      Manage information
                    </Link>
                    {/* <a href="#" className="manage-info">
                      Manage information
                    </a> */}
                  </div>
                </Col>
                <Col span={12}>
                  <ProfileMap
                    type="Checkout"
                    position={selectedPostion}
                    setPosition={setSelectedPostion}
                    onSelected={setSelectedLocation}
                  />
                </Col>
              </Row>
            </div>
            {carts.map((item: any, index: number) => {
              return (
                <List
                  key={index}
                  className="checkout-list"
                  header={
                    <div className="checkout-header">
                      <div className="farm-info">
                        <div className="name">
                          <b>{item[0].farm_details.display_name}</b>
                          <StarFilled
                            style={{ color: "var(--secondary-500)" }}
                          />{" "}
                          4.0
                        </div>
                        <div className="location">
                          <img src={locationMarker} alt="contact" width={20} />
                          Alberta
                        </div>
                      </div>
                      <Button className="contact-btn">
                        <img
                          src={contact}
                          alt="contact"
                          width={20}
                          className="contact-icon"
                        />
                        Contact Producer
                      </Button>
                    </div>
                  }
                  bordered
                  dataSource={item}
                  renderItem={(ite) => {
                    return (
                      <List.Item>
                        <CartItem
                          data={ite}
                          productSelected={productSelected}
                          setProductSelected={setProductSelected}
                          type={"checkout"}
                        />
                      </List.Item>
                    );
                  }}
                />
              );
            })}
            <div className="checkout-info">
              <div className="title-group">
                <div className="title">Shipping Options</div>
              </div>
              <Radio.Group
                onChange={(e: any) => {
                  setOrderPayload({
                    ...orderPayload,
                    shipping_method_id:
                      e.target["data-label"] === "consumer_pickup"
                        ? 1
                        : e.target["data-label"] === "shipping_producer"
                        ? 2
                        : 3,
                    shipping_fee:
                      Math.round(
                        Number(e.target.value.slice(0, -2)) *
                          orderPayload.orders[0].distance *
                          100
                      ) / 100,
                  });
                  setShippingFeeRadio(e.target.value);
                }}
                value={shippingFeeRadio}
              >
                {shippingOptions != null &&
                  Object.entries(shippingOptions).map(
                    ([key, value]: any, index: number) => {
                      if (key !== "carrier_shipping") {
                        return (
                          <Radio
                            key={index}
                            data-label={key}
                            value={
                              key === "consumer_pickup"
                                ? `0-${index}`
                                : `${value}-${index}`
                            }
                          >
                            <div className="shipping-item">
                              <div className="shipping-title">
                                {key === "consumer_pickup"
                                  ? "Consumer Pickup"
                                  : "Delivered"}
                                {key !== "consumer_pickup" && (
                                  <span className="description">
                                    Estimate arrived: Dec 1 - Dec 5 | Distance:{" "}
                                    {Helpers.formatNumber(
                                      orderPayload.orders[0].distance,
                                      0
                                    ) + " km"}
                                  </span>
                                )}
                              </div>
                              {key === "consumer_pickup" ? (
                                <div className="shipping-price">
                                  <span className="premium-notice">
                                    <img
                                      src={crownImg}
                                      width={12}
                                      alt="premium-icon"
                                    />
                                    Update to Premium
                                    <span className="price">$0.00</span>
                                  </span>
                                </div>
                              ) : (
                                <div className="shipping-price">
                                  $
                                  {Helpers.formatNumber(
                                    value * orderPayload.orders[0].distance,
                                    2
                                  )}
                                  <span className="description">
                                    Shipping rate: ${value} / km
                                  </span>
                                </div>
                              )}
                            </div>
                          </Radio>
                        );
                      }
                    }
                  )}
              </Radio.Group>
            </div>
            <div className="checkout-info">
              <div className="title-group">
                <div className="title">Payment Methods</div>
              </div>
              <Radio.Group
                onChange={(e) => {
                  setOrderPayload({
                    ...orderPayload,
                    payment_info_id: e.target.value,
                  });
                }}
                value={orderPayload.payment_info_id}
                className="payment-method"
              >
                <Radio
                  value={orderPayload.payment_info_id}
                  className="payment-item"
                >
                  <img src={cash} alt="cash" width={30} /> Cash
                </Radio>
                  {allPayment?.map((item: any, index: number) => {
                    return (
                    <Radio
                      key={index}
                      value={item.payment_info_id}
                      className="payment-item"
                    >
                      <img
                        src={
                          cardIcons[
                            item.payment_type === "paypal"
                              ? item.payment_type
                              : item?.card_type
                          ] ?? debit
                        }
                        alt={`${item?.card_type}`}
                        width={30}
                      />{" "}
                      {item.card_type !== "paypal" ? (
                        <span className="ms-2">
                          {Helpers.hideCardNumber(item?.card_number ?? "")}
                        </span>
                      ) : (
                        <span className="ms-2">
                          ********{item.paypal_email?.slice(-10)}
                        </span>
                      )}
                    </Radio>
                  );
                })}
              </Radio.Group>
              <Select
                className="add-new-card"
                value={"+ Add New Supported Payment Methods"}
                onChange={(value) => {
                  if (value === "new-card") {
                    setIsOpenNewCard(true);
                  }
                }}
              >
                <Select.Option value="new-card" key={1}>
                  <PlusOutlined /> Add New Card
                </Select.Option>
              </Select>
            </div>
            <PaymentModal
              isOpenNewCard={isOpenNewCard}
              setIsOpenNewCard={setIsOpenNewCard}
              setAllPayment={setAllPayment}
            />
          </Col>
          <Col span={8}>
            <div className="summary">
              <div className="summary-box">
                <div className="summary-title">Summary</div>
                <div className="summary-item">
                  {
                    productSelected.filter((item: any) => item.isSelected)
                      .length
                  }{" "}
                  items:
                  <div className="price">
                    ${Helpers.formatNumber(orderPayload.total_price, 2)}
                  </div>
                </div>
                <div className="summary-item">
                  Estimated tax (10%):{" "}
                  <div className="price">
                    ${Helpers.formatNumber(
                      Math.round(orderPayload.total_price * 0.1 * 100) / 100,
                      2
                    )}
                  </div>
                </div>
                <div className="summary-item">
                  Shipping & handling:{" "}
                  <div className="price">
                    ${Helpers.formatNumber(orderPayload.shipping_fee, 2)}
                  </div>
                </div>
              </div>
              <Divider className="divider" />
              <div className="subtotal-box">
                <div className="subtotal-content">
                  Subtotal
                  <div className="subtotal-price">
                    $
                    {Helpers.formatNumber(
                      orderPayload.total_price +
                        orderPayload.shipping_fee +
                        orderPayload.estimate_tax,
                      2
                    )}
                  </div>
                </div>
                <Button
                  className="checkout-btn"
                  onClick={() => handleCheckout()}
                >
                  Complete Purchase
                </Button>
                <div className="paypal-btn mt-2">
                  <PayPalButtons
                    message={{ color: "white" }}
                    style={{ layout: "horizontal", shape: "pill", height: 44 }}
                    createOrder={onCreatePaypalOrder}
                    onApprove={(data: any, actions: any) => {
                      return actions.order.capture().then((details: any) => {
                        Helpers.notification.success("Payment successful");
                        handleCheckout();
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Checkout;
